import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { useSettingsStore } from "~/stores/SettingsStore.js"
import { useUserStore } from "~/stores/UserStore.js"
import { useLocalePath } from '#imports';


export default defineNuxtRouteMiddleware((to, from) => {
    if (!useSettingsStore().bool('settings.authentication_required') || useUserStore().isLoggedIn()) {
        return;
    }


    const name =  to?.name?.split('_')[0] || '';

    useState('authRequired', () => true);
    if (name === 'register' || name.startsWith('subaccounts-expired') || name.startsWith('login') || name.startsWith('reset-password-code')) {
        return;
    }
    const localePath = useLocalePath();
    let url = localePath({name: 'login'}) + '/';
    if (!to?.name?.startsWith('index') && !to?.name?.startsWith('logout')) {
        url += '?redirect=' + encodeURIComponent(to.fullPath);
    }
    return navigateTo(url);
})
